__webpack_require__.p = "/speechcraft/";